import React from "react";
import { Redirect, Route, useParams } from "react-router-dom";
import { useAuthState } from '../Context'

const AppRoute = ({ component: Component, path, isPrivate, ...rest }) => {

    const userDetails = useAuthState()
    //const {datasetP, leftDateP, viewTypeP} = useParams()
    return (
        <Route
            path={path}
            render={props =>
                isPrivate && !Boolean(userDetails.token) ? (
                    <Redirect
                        to={{ pathname: "/Login" }}
                    />
                ) : (
                    <Component {...props} />
                )
            }
            {...rest}
        />
    )
}

export default AppRoute
